import { useQuery } from "@tanstack/react-query";
import { fetchCameraMemos } from "../api/fetch-camera-memos";

export const CAMERA_MEMOS_QUERY_KEY = "cameraMemos";

export function useCameraMemos(branchUid: string | undefined, versionId?: number) {
  return useQuery({
    queryKey: [CAMERA_MEMOS_QUERY_KEY, branchUid, versionId],
    queryFn: () => fetchCameraMemos(branchUid!, versionId),
    enabled: Boolean(branchUid),
  });
}
